import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { StatusIcon } from './status-icon.component';

@NgModule({
	declarations: [StatusIcon],
	imports: [CommonModule],
	exports: [StatusIcon],
	providers: [],
})
export class StatusIconModule {}
